import Constantes from '@/Constantes';
import { obtenerUsuario } from '@/EventBus';

const HttpService = {
	formdata: async (ruta, fd) => {
		const token = obtenerUsuario();
		const respuestaRaw = await fetch(Constantes.URL_API + ruta, {
			credentials: 'include',
			method: 'POST',
			body: fd,
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return await respuestaRaw.json();
	},
	post: async (ruta, datos) => {
		const token = obtenerUsuario();

		try {
			const respuestaRaw = await fetch(Constantes.URL_API + ruta, {
				credentials: 'include',
				method: 'POST',
				body: JSON.stringify(datos),
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token}`,
				},
			});
			return await respuestaRaw.json();
		} catch (error) {
			return {
				success: false,
				message: 'Error en la solicitud',
				error: error.message,
			};
		}
	},
	put: async (ruta, datos) =>
		fetch(Constantes.URL_SERVIDOR + ruta, {
			credentials: 'include',
			method: 'PUT',
			body: JSON.stringify(datos),
		}).then(r => r.json()),
	get: async ruta => {
		const token = obtenerUsuario();
		try {
			const respuestaRaw = await fetch(Constantes.URL_API + ruta, {
				credentials: 'include',
				method: 'GET',
				headers: {
					Authorization: `Bearer ${token}`,
				},
			});
			return await respuestaRaw.json();
		} catch (error) {
			return {
				success: false,
				message: 'Error en la solicitud',
				error: error.message,
			};
		}
	},
	download: async (ruta, filename) => {
		const token = obtenerUsuario();
		const respuestaRaw = await fetch(Constantes.URL_API + ruta, {
			credentials: 'include',
			method: 'GET',
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		if (!respuestaRaw.ok) {
			return respuestaRaw.json();
		}

		// Convertir la respuesta a un blob
		const blob = await respuestaRaw.blob();

		// Crear un enlace temporal para descargar el archivo
		const link = document.createElement('a');
		const url = window.URL.createObjectURL(blob);
		link.href = url;
		link.setAttribute('download', filename);
		document.body.appendChild(link);
		link.click();

		// Limpiar el objeto URL y el enlace temporal
		link.remove();
		window.URL.revokeObjectURL(url);
		return { success: respuestaRaw.status, message: 'Descarga success' };
	},
	delete: async ruta =>
		fetch(Constantes.URL_SERVIDOR + ruta, {
			credentials: 'include',
			method: 'DELETE',
		}).then(r => r.json()),
};
export default HttpService;
